// ART-241 "Pay with Venmo" — the pre-filled Venmo links. We are NOT a payment processor: these open Venmo (the
// app on mobile, the web on desktop) with the payment pre-filled, and the tour manager pays out of their OWN
// Venmo. Our "Mark paid" flag is the source of truth (Venmo gives no completion callback). The amount/note
// prefill params are community-known, not an official API, so they are best-effort — the recipient is the
// reliable field, and nothing breaks if a value does not populate.

export interface VenmoPayment {
  /** The recipient's Venmo username, stored WITHOUT the leading '@'. */
  username: string;
  amountCents: number;
  note: string;
}

/** Whole-dollar-and-cents string for the amount param (Venmo wants a plain decimal). */
function dollars(cents: number): string {
  return (Math.max(0, cents) / 100).toFixed(2);
}

/** The note the mockup specifies: `{Run/Show/Tour title}: per diem + travel`. */
export function venmoNote(scopeTitle: string): string {
  return `${scopeTitle}: per diem + travel`;
}

/** The NATIVE deep link — opens the Venmo app pre-filled (mobile only, via a location.assign-style seam). */
export function venmoDeepLink(p: VenmoPayment): string {
  const q = new URLSearchParams({
    txn: "pay",
    recipients: p.username,
    amount: dollars(p.amountCents),
    note: p.note,
  });
  return `venmo://paycharge?${q.toString()}`;
}

/** The WEB link — opened on desktop ("Open venmo.com") and encoded into the desktop QR. */
export function venmoWebLink(p: VenmoPayment): string {
  const q = new URLSearchParams({ txn: "pay", amount: dollars(p.amountCents), note: p.note });
  // venmo.com is a fixed THIRD-PARTY vendor URL, not one of our app API bases (which the rule guards).
  // eslint-disable-next-line no-restricted-syntax -- external vendor deep-link target, not an app base
  return `https://venmo.com/${encodeURIComponent(p.username)}?${q.toString()}`;
}
